<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('configuration.configuration')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>{{ trans('ip_filter.ip_filter') }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="ip-filter"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner admin-config-panel__inner--wide">
                    <div class="admin-linear-head">
                        <div>
                            <span class="admin-linear-head__eyebrow">Security rules</span>
                            <h4 class="admin-linear-head__title">{{ trans('ip_filter.ip_filter') }}</h4>
                            <p class="admin-linear-head__description">Define allowed or blocked IP ranges with concise descriptions so operators can audit access quickly.</p>
                        </div>
                        <div class="admin-linear-stat" role="status">
                            <span>{{ trans('ip_filter.ip_filter_list') }}</span>
                            <strong>{{ ip_filters && ip_filters.total ? ip_filters.total : 0 }}</strong>
                        </div>
                    </div>
                    <show-tip module="ip_filter" tip="tip_ip_filter"></show-tip>

                    <section class="admin-config-list-section" aria-labelledby="admin-config-ip-filter-list-title">
                    <header class="admin-config-list-head admin-config-list-head--split">
                        <div class="admin-config-list-head__text">
                            <h4 id="admin-config-ip-filter-list-title" class="admin-config-list-head__title">
                                {{trans('ip_filter.ip_filter_list')}}
                            </h4>
                            <p
                                v-if="ip_filters && ip_filters.total"
                                class="admin-config-list-head__sub"
                                role="status"
                            >
                                {{trans('general.total_result_found',{'count' : ip_filters.total})}}
                            </p>
                            <p
                                v-else-if="ip_filters"
                                class="admin-config-list-head__sub admin-config-list-head__sub--empty"
                                role="status"
                            >
                                {{trans('general.no_result_found')}}
                            </p>
                        </div>
                        <div class="admin-config-list-head__actions">
                            <button
                                type="button"
                                class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid"
                                v-b-modal.modal-ip-filter-create
                            >
                                <admin-icon name="plus"></admin-icon> {{ trans('general.add_new') }}
                            </button>
                        </div>
                    </header>

                    <div class="admin-list-table-card admin-config-list-card" v-if="ip_filters && ip_filters.total">
                        <div class="table-responsive">
                            <table class="table admin-data-table admin-data-table--config-list admin-linear-table mb-0">
                                <thead>
                                    <tr>
                                        <th scope="col">{{trans('ip_filter.start_ip')}}</th>
                                        <th scope="col">{{trans('ip_filter.end_ip')}}</th>
                                        <th scope="col">{{trans('ip_filter.description')}}</th>
                                        <th scope="col" class="admin-table-actions-cell">{{trans('general.action')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="ip_filter in ip_filters.data" :key="ip_filter.id">
                                        <td><span class="admin-linear-code">{{ ip_filter.start_ip }}</span></td>
                                        <td><span class="admin-linear-code">{{ ip_filter.end_ip }}</span></td>
                                        <td>
                                            <strong class="admin-linear-primary">{{ ip_filter.description || '-' }}</strong>
                                        </td>
                                        <td class="admin-table-actions-cell">
                                            <table-row-action-dropdown>
                                                <b-dropdown-item-button @click.prevent="editIpFilter(ip_filter)">
                                                    <admin-icon name="pencil"></admin-icon> {{ trans('general.edit') }}
                                                </b-dropdown-item-button>
                                                <b-dropdown-item-button
                                                    v-confirm="{ok: confirmDelete(ip_filter)}"
                                                    class="admin-row-actions__danger"
                                                >
                                                    <admin-icon name="trash"></admin-icon> {{ trans('ip_filter.delete_ip_filter') }}
                                                </b-dropdown-item-button>
                                            </table-row-action-dropdown>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="admin-table-pagination-wrap">
                            <pagination-record :page-length.sync="filterIpFilterForm.page_length" :records="ip_filters" @updateRecords="getIpFilters" @change.native="getIpFilters"></pagination-record>
                        </div>
                    </div>
                    <module-info v-if="ip_filters && !ip_filters.total" module="ip_filter" title="module_info_title" description="module_info_description" icon="ellipsis-v"></module-info>
                    </section>
                </div>
            </div>
        </div>

        <b-modal
            id="modal-ip-filter-create"
            hide-footer
            centered
            lazy
            modal-class="admin-modal-pro"
            content-class="admin-modal-pro__content"
        >
            <template #modal-title>{{trans('ip_filter.add_new_ip_filter')}}</template>
            <ip-filter-form @completed="getIpFilters" @cancel="$bvModal.hide('modal-ip-filter-create')"></ip-filter-form>
        </b-modal>
    </div>
</template>


<script>
    import configurationSidebar from '../system-config-sidebar'
    import ipFilterForm from './form'

    export default {
        components : { configurationSidebar,ipFilterForm },
        data() {
            return {
                ip_filters: {
                    total: 0,
                    data: []
                },
                filterIpFilterForm: {
                    page_length: helper.getConfig('page_length')
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('ip_filter')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getIpFilters();
        },
        methods: {
            getIpFilters(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                this.$bvModal.hide('modal-ip-filter-create');
                let url = helper.getFilterURL(this.filterIpFilterForm);
                axios.get('/api/ip-filter?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.ip_filters = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editIpFilter(ip_filter){
                this.$router.push('/configuration/ip-filter/'+ip_filter.id+'/edit');
            },
            confirmDelete(ip_filter){
                return dialog => this.deleteIpFilter(ip_filter);
            },
            deleteIpFilter(ip_filter){
                axios.delete('/api/ip-filter/'+ip_filter.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getIpFilters();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-stat {
    min-width: 8.5rem;
    padding: 0.85rem 1rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: var(--dash-pro-surface);
    text-align: right;
}

.admin-linear-stat span {
    display: block;
    color: var(--dash-pro-muted);
    font-size: 0.72rem;
    font-weight: 700;
}

.admin-linear-stat strong {
    display: block;
    margin-top: 0.25rem;
    color: var(--dash-pro-text);
    font-size: 1.65rem;
    letter-spacing: -0.06em;
}

.admin-linear-code {
    display: inline-flex;
    align-items: center;
    min-height: 1.65rem;
    padding: 0.15rem 0.55rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: 999px;
    color: var(--dash-pro-text-secondary);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.02em;
}

.admin-linear-primary {
    color: var(--dash-pro-text);
    font-weight: 650;
}

@media (max-width: 767.98px) {
    .admin-linear-head {
        align-items: stretch;
        flex-direction: column;
    }

    .admin-linear-stat {
        text-align: left;
    }
}
</style>
